import {inject} from '@angular/core';
import {SecurityService} from './security.service';
import { CanActivateFn, Router } from '@angular/router';
import { RootRoute, SettingsRoute } from '../shared/models/angular-routing';
import { firstValueFrom } from 'rxjs';

export const adminGuard: CanActivateFn = (route, state) => {
  const securityService = inject(SecurityService);

  const settingsRoute = state.url.split('/').filter(Boolean)[1] || '';
  return securityService.hasPermission(settingsRoute as SettingsRoute);
};

export const defaultSettingsRoute = async () => {
  const securityService = inject(SecurityService);
  const router = inject(Router);
  if (await firstValueFrom(securityService.isAdmin$())) {
    await router.navigate([`/${RootRoute.SETTINGS}`, SettingsRoute.MANAGE_USERS]);
  } else {
    await router.navigate([`/${RootRoute.SETTINGS}`, SettingsRoute.MY_ACCOUNT]);
  }
  return false;
};
